module.exports = __webpack_public_path__ + "img/mohawk.fcb0141d.svg";